// extracted by mini-css-extract-plugin
export default {"incutWrapper":"kN1iH1y0","mobile":"mobile"};